// extracted by mini-css-extract-plugin
module.exports = {"loadingcontainer":"Loading_loadingcontainer__ezgIC","loading":"Loading_loading__FWELY"};